// languages

const bosnian = 'bs';
const english = 'en';

export { bosnian, english };
